export const dynamicFields = {
  ownerFields: [
    {
      value: 'FirstName',
      label: 'First Name',
    },
    {
      value: 'LastName',
      label: 'Last Name',
    },
    {
      value: 'email',
      label: 'Email Address',
    },
  ],
  senderFields: [
    {
      value: 'FirstName',
      label: 'First Name',
    },
    {
      value: 'LastName',
      label: 'Last Name',
    },
    {
      value: 'email',
      label: 'Email Address',
    },
  ],
};
